import PropTypes from 'prop-types';

export const ChangeServiceLinkType = PropTypes.shape({
  disableUtmParams: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.bool,
  url: PropTypes.string,
});

export const LocationType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  address: PropTypes.string,
  heading: PropTypes.string,
  code: PropTypes.string,
  image: PropTypes.shape({
    gatsbyImageData: PropTypes.object,
  }),
  distanceInKm: PropTypes.number,
  hasFreeParking: PropTypes.bool,
  flagshipStoreLabel: PropTypes.string,
});

export const LocationDataType = PropTypes.shape({
  bookingButtonLabel: PropTypes.string,
  description: PropTypes.shape({
    markdown: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  distancePlaceholder: PropTypes.string,
  goToNextStep: PropTypes.func,
  goToPrevStep: PropTypes.func,
  id: PropTypes.string,
  isNextStep: PropTypes.bool,
  isPrevStep: PropTypes.bool,
  locations: PropTypes.oneOfType([LocationType, PropTypes.arrayOf(LocationType)]),
  mobileListTabName: PropTypes.string,
  mobileMapTabName: PropTypes.string,
  name: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  title: PropTypes.string,
  sortingAlgorithm: PropTypes.string,
  useWoosmapApi: PropTypes.bool,
  showTimeSlots: PropTypes.bool,
  showDailyFilters: PropTypes.bool,
  noDatesAvailableLT: PropTypes.string,
  waitlistButtonLabelLT: PropTypes.string,
  confirmationDialogLabelLT: PropTypes.string,
  cancelDialogLabelLT: PropTypes.string,
});

export const SearchedLocationType = PropTypes.shape({
  name: PropTypes.string,
  formatted_address: PropTypes.string,
  targetLocation: PropTypes.shape({
    latitude: PropTypes.string,
    longitude: PropTypes.string,
  }),
});

export const StepLocationCommonPropTypes = {
  stepLocation: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.shape({
      markdown: PropTypes.shape({
        html: PropTypes.string,
      }),
    }),
  }),
  allLocations: PropTypes.oneOfType([LocationType, PropTypes.arrayOf(LocationType)]),
  closestLocationsState: PropTypes.array,
  selectedLocationState: PropTypes.array,
  resetSelectedLocation: PropTypes.func,
  locationsWrapperRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.elementType })]),
  locationsRefs: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.elementType })]),
  isMapLoadedState: PropTypes.array,
  changeServiceLink: PropTypes.shape({
    disableUtmParams: PropTypes.bool,
    title: PropTypes.string,
    type: PropTypes.bool,
    url: PropTypes.string,
  }),
};
